import React from 'react';
import './TwoColumnCard.scss';
import {
    TwoColumnCardColumn,
    TwoColumnCardColumnProps,
} from './TwoColumnCardColumn';
import { AccentedText } from '../AccentedText/AccentedText';

export interface TwoColumnCardProps {
    columns: [TwoColumnCardColumnProps, TwoColumnCardColumnProps];
    darkMode: boolean;
    headline: string;
}

export const TwoColumnCard = (props: TwoColumnCardProps) => {
    if (
        !props.columns ||
        props.columns.length < 2 ||
        props.columns.some((col) => !col.heading)
    ) {
        return (
            <p className="kite-container component-error">
                ERROR: Two column -- both columns must be populated.
            </p>
        );
    }
    return (
        <section
            className={`themed-container c--two-column ${
                props.darkMode ? `dark` : `light`
            }`}
        >
            <div className="kite-container">
                {props.headline && (
                    <h2 className="container-headline">
                        <AccentedText>{props.headline}</AccentedText>
                    </h2>
                )}
                {props.columns.map((col, idx) => (
                    <TwoColumnCardColumn key={idx} {...col} />
                ))}
            </div>
        </section>
    );
};
